var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwint = function SvgTwint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.48 215.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 237.46,
    cy: 269.28,
    r: 77.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffc800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 190.76,
    cy: 273.74,
    r: 71.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00b0e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#01a5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0292cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0377ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0455a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054696"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 569.48,
    height: 215.81,
    rx: 7.92,
    ry: 7.92
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.17 145.03a7.34 7.34 0 0 1-3.31 5.73l-64.31 37.13a7.34 7.34 0 0 1-6.62 0l-64.32-37.13a7.34 7.34 0 0 1-3.31-5.73V70.77a7.34 7.34 0 0 1 3.31-5.73l64.32-37.13a7.34 7.34 0 0 1 6.62 0l64.31 37.13a7.34 7.34 0 0 1 3.31 5.73Zm357.01-68.91h-57.61v13.69h20.65v58.8h16.3v-58.8h20.66zm-261.53 0h-57.62v13.69h20.66v58.8h16.3v-58.8h20.66zm166.64-2.3c-18.11 0-28.2 11.56-28.2 28.28v46.51h16.11v-46.86c0-7.29 4.33-12.88 12.27-12.88s12.22 6.64 12.22 12.88v46.86h16.11V102.1c0-16.72-10.43-28.28-28.54-28.28Zm-60.86 2.3v72.49h16.19V76.12zm-54.61 28.72.54 3.22 15.12 40.55h6.6l20.61-72.49h-15.94l-9.81 38.08-.58 4.08-.8-4.08-13.12-38.08h-5.25l-13.12 38.08-.79 4.08-.58-4.08-9.81-38.08h-15.94l20.61 72.49h6.6l15.12-40.55z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.92 297.59-16.75 24.58-8.6-13.17 9.93-14.8c1.84-2.65 5.77-9.88 1.22-19.8a20.61 20.61 0 0 0-37.38 0 19 19 0 0 0 1.13 19.5s5.48 8.08 10.1 14.89l7.43 10.74 11.24 17.15a6.41 6.41 0 0 0 5 2.84c3 0 4.83-2.67 5.06-3l26.29-38.92Zm-33 .63s-4.39-6.65-7.24-11.31a8.33 8.33 0 1 1 14.49 0c-2.8 4.65-7.17 11.31-7.17 11.31Z",
    style: {
      fill: "url(#a)"
    },
    transform: "translate(-136.2 -189.51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.8 321.38-16.47-23.13s-4.39-6.68-7.24-11.33a8.29 8.29 0 0 1 7.24-12.43 8.8 8.8 0 0 1 2.41.33l5.82-10.64a20.53 20.53 0 0 0-26.86 10.21 19 19 0 0 0 1.13 19.5l28.8 42.66c.24.37 2.07 3.06 5.13 3.06a6.4 6.4 0 0 0 5.06-3l8.68-13.25-7.45-11Z",
    style: {
      fill: "url(#b)"
    },
    transform: "translate(-136.2 -189.51)"
  }));
};
export default SvgTwint;